var Const = /** @class */ (function () {
    function Const() {
    }
    Const.RUN_LANGUAGE_API = '/RUN_LANGUAGE_API';
    //trading-tools
    Const.GET_JURISDICTION_TAX_RESIDENCE = '/GET_JURISDICTION_TAX_RESIDENCE';
    Const.RUN_GET_AUTOCHARTIST_DATA = '/RUN_GET_AUTOCHARTIST_DATA';
    Const.RUN_GET_CURRENT_NEWS = '/RUN_GET_CURRENT_NEWS';
    Const.RUN_GET_CURRENT_NEWS_DETAIL = '/RUN_GET_CURRENT_NEWS_DETAIL';
    Const.GET_CURRENT_NEWS_DETAIL = '/GET_CURRENT_NEWS_DETAIL';
    Const.SET_CURRENT_NEWS_DETAIL = '/SET_CURRENT_NEWS_DETAIL';
    Const.RUN_GET_SIGNAL_CENTRE_DATA = '/RUN_GET_SIGNAL_CENTRE_DATA';
    Const.RUN_GET_ECONOMIC_CALENDER_DATA = '/RUN_GET_ECONOMIC_CALENDER_DATA';
    Const.RUN_COUPON_PLAN = '/RUN_COUPON_PLAN';
    Const.RUN_GET_SUB_PLAN_LIST = '/RUN_GET_SUB_PLAN_LIST';
    Const.RUN_GET_SUB_PLAN_DETAIL = '/RUN_GET_SUB_PLAN_DETAIL';
    Const.RUN_SUB_OPERATION_LINK = '/RUN_SUB_OPERATION_LINK';
    Const.RUN_SUB_OPERATION = '/RUN_SUB_OPERATION';
    Const.RUN_CREATE_SUB_TICKET = '/RUN_CREATE_SUB_TICKET';
    Const.RUN_UNSUB_SERVICE = '/RUN_UNSUB_SERVICE';
    Const.RUN_GET_VPS_LIST = '/RUN_GET_VPS_LIST';
    Const.RUN_GET_VPS_DETAIL = '/RUN_GET_VPS_DETAIL';
    Const.RUN_VPS_RESTART = '/RUN_VPS_RESTART';
    Const.RUN_VPS_REBOOT = '/RUN_VPS_REBOOT';
    Const.RUN_VPS_SHUTDOWN = '/RUN_VPS_SHUTDOWN';
    Const.RUN_VPS_CHANGE_PASSWORD = '/RUN_VPS_CHANGE_PASSWORD';
    Const.RUN_GET_COUPON_LIST = '/RUN_GET_COUPON_LIST';
    Const.RUN_CHECK_COUPON_VALIDITY = '/RUN_CHECK_COUPON_VALIDITY';
    Const.SET_COUPON_LIST = '/SET_COUPON_LIST';
    Const.GET_COUPON_LIST = '/GET_COUPON_LIST';
    Const.SET_VPS_LIST = '/SET_VPS_LIST';
    Const.GET_VPS_LIST = '/GET_VPS_LIST';
    Const.SET_VPS_DETAIL = '/SET_VPS_DETAIL';
    Const.GET_VPS_DETAIL = '/GET_VPS_DETAIL';
    Const.GET_EUROPEAN_COUNTRY_LIST = '/GET_EUROPEAN_COUNTRY_LIST';
    Const.SET_SIGNAL_CENTRE = '/SET_SIGNAL_CENTRE';
    Const.GET_SIGNAL_CENTRE = '/GET_SIGNAL_CENTRE';
    Const.SET_AUTO_CHARTIST = '/SET_AUTO_CHARTIST';
    Const.GET_AUTO_CHARTIST = '/GET_AUTO_CHARTIST';
    Const.SET_ECONOMIC_CALENDER_DATA = '/SET_ECONOMIC_CALENDER_DATA';
    Const.GET_ECONOMIC_CALENDER_DATA = '/GET_ECONOMIC_CALENDER_DATA';
    Const.SET_CURRENT_NEWS = '/SET_CURRENT_NEWS';
    Const.GET_CURRENT_NEWS = '/GET_CURRENT_NEWS';
    Const.SET_SUB_PLAN_LIST = '/SET_SUB_PLAN_LIST';
    Const.GET_SUB_PLAN_LIST = '/GET_SUB_PLAN_LIST';
    Const.SET_SUB_PLAN_DETAIL = '/SET_SUB_PLAN_DETAIL';
    Const.GET_SUB_PLAN_DETAIL = '/GET_SUB_PLAN_DETAIL';
    //user
    Const.RUN_GET_USER_PROFILE = '/RUN_GET_USER_PROFILE';
    Const.RUN_GET_USER_REGISTERATION_STEP_DATA = '/RUN_GET_USER_REGISTERATION_STEP_DATA';
    Const.RUN_GET_COUNTRIES_LIST = '/RUN_GET_COUNTRIES_LIST';
    Const.RUN_GET_CITIES_LIST = '/RUN_GET_CITIES_LIST';
    Const.RUN_USER_NOTIFICATIONS = '/RUN_USER_NOTIFICATIONS';
    Const.SET_USER_PROFILE = '/SET_USER_PROFILE';
    Const.GET_USER_PROFILE = '/GET_USER_PROFILE';
    Const.SET_USER_NOTIFICATIONS = '/SET_USER_NOTIFICATIONS';
    Const.GET_USER_NOTIFICATIONS = '/GET_USER_NOTIFICATIONS';
    Const.SET_COUNTRIES_LIST = '/SET_COUNTRIES_LIST';
    Const.GET_COUNTRIES_LIST = '/GET_COUNTRIES_LIST';
    Const.SET_CITIES_LIST = '/SET_CITIES_LIST';
    Const.GET_CITIES_LIST = '/GET_CITIES_LIST';
    Const.GET_COUNTRY_TAX_RESIDENCE_NATIONALITY = '/GET_COUNTRY_TAX_RESIDENCE_NATIONALITY';
    Const.GET_EMP_STATUS = '/GET_EMP_STATUS';
    Const.GET_AC_OPENING_REASON = '/GET_AC_OPENING_REASON';
    Const.GET_SOURCE_OF_FUNDS = '/GET_SOURCE_OF_FUNDS';
    Const.GET_NATURE_OF_TRANSACTION = '/GET_NATURE_OF_TRANSACTION';
    Const.GET_ORIGIN_OF_FUNDS = '/GET_ORIGIN_OF_FUNDS';
    Const.GET_DOCS_LINK = '/GET_DOCS_LINK';
    Const.GET_GENDER_LIST = '/GET_GENDER_LIST';
    Const.GET_IS_TRADING_EXPERIENCE = '/GET_IS_TRADING_EXPERIENCE';
    Const.GET_OCCUPATION = '/GET_OCCUPATION';
    Const.GET_EDUCATION = '/GET_EDUCATION';
    Const.GET_EMPLOYMENT = '/GET_EMPLOYMENT';
    Const.GET_EST_YEARLY_INCOME = '/GET_EST_YEARLY_INCOME';
    Const.GET_EST_NET_WORTH = '/GET_EST_NET_WORTH';
    Const.GET_NET_DISPOSABLE_INCOME = '/GET_NET_DISPOSABLE_INCOME';
    Const.GET_INVESTED_TRADING_AMOUNT = '/GET_INVESTED_TRADING_AMOUNT';
    Const.GET_TRADING_TURNOVER = '/GET_TRADING_TURNOVER';
    Const.GET_ANT_ACCOUNT_TURNOVER = '/GET_ANT_ACCOUNT_TURNOVER';
    Const.GET_TIN_PASSPORT_OPTION = '/GET_TIN_PASSPORT_OPTION';
    //manage accounts
    Const.RUN_AMOUNT_CONVERSION_API = '/RUN_AMOUNT_CONVERSION_API';
    Const.RUN_ACCOUNT_PASSWORD_REQUEST_OTP = '/RUN_ACCOUNT_PASSWORD_REQUEST_OTP';
    Const.RUN_ACCOUNT_PASSWORD_CHECK_OTP = '/RUN_ACCOUNT_PASSWORD_CHECK_OTP';
    Const.RUN_ACCOUNT_LEVERAGE_CHECK_OTP = '/RUN_ACCOUNT_LEVERAGE_CHECK_OTP';
    Const.RUN_INTERNAL_TRANSFER_CHECK_OTP = '/RUN_INTERNAL_TRANSFER_CHECK_OTP';
    Const.RUN_RESEND_EMAIL_LINK_ACCOUNTS = '/RUN_RESEND_EMAIL_LINK_ACCOUNTS';
    //trading accounts
    Const.RUN_GET_ACCOUNT_PRIORITY_LIST = '/RUN_GET_ACCOUNT_PRIORITY_LIST';
    Const.RUN_GET_TRADING_ACCOUNT_LIST = '/RUN_GET_TRADING_ACCOUNT_LIST';
    Const.RUN_GET_ACCOUNT_HISTORY = '/RUN_GET_ACCOUNT_HISTORY';
    Const.RUN_ADD_LAST_SELECT_TRADING_ACCOUNT = '/RUN_ADD_LAST_SELECT_TRADING_ACCOUNT';
    Const.RUN_GET_TRADING_ACCOUNT_DETAILS = '/RUN_GET_TRADING_ACCOUNT_DETAILS';
    Const.RUN_CREATE_ACCOUNT = '/RUN_CREATE_ACCOUNT';
    Const.RUN_CREATE_API_SUBSCRIPTION = '/RUN_CREATE_API_SUBSCRIPTION';
    Const.SET_TRADING_ACCOUNT_LIST = '/SET_TRADING_ACCOUNT_LIST';
    Const.GET_TRADING_ACCOUNT_LIST = '/GET_TRADING_ACCOUNT_LIST';
    Const.SET_LIVE_ACCOUNT_LIST = '/SET_LIVE_ACCOUNT_LIST';
    Const.GET_LIVE_ACCOUNT_LIST = '/GET_LIVE_ACCOUNT_LIST';
    Const.SET_DEMO_ACCOUNT_LIST = '/SET_DEMO_ACCOUNT_LIST';
    Const.GET_DEMO_ACCOUNT_LIST = '/GET_DEMO_ACCOUNT_LIST';
    Const.SET_LAST_SELECT_TRADING_ACCOUNT = '/SET_LAST_SELECT_TRADING_ACCOUNT';
    Const.GET_LAST_SELECT_TRADING_ACCOUNT = '/GET_LAST_SELECT_TRADING_ACCOUNT';
    Const.SET_ACCOUNT_DETAILS = '/SET_ACCOUNT_DETAILS';
    Const.GET_ACCOUNT_DETAILS = '/GET_ACCOUNT_DETAILS';
    Const.GET_CURRENCY = '/GET_CURRENCY';
    //deposit
    Const.RUN_DEMO_DEPOSIT = '/RUN_DEMO_DEPOSIT';
    Const.RUN_TRANS_LIMIT_CURRENCY = '/RUN_TRANS_LIMIT_CURRENCY';
    Const.RUN_GET_DEPOSIT_LIST = '/RUN_GET_DEPOSIT_LIST';
    Const.RUN_GET_USER_CAN_DEPOSIT = '/RUN_GET_USER_CAN_DEPOSIT';
    Const.RUN_CREDIT_CARD_DEPOSIT = '/RUN_CREDIT_CARD_DEPOSIT';
    Const.RUN_GET_TRANSACTION_STATUS = '/RUN_GET_TRANSACTION_STATUS';
    Const.GET_DEPOSIT_TYPE = '/GET_DEPOSIT_TYPE';
    Const.SET_DEPOSIT_LIST = '/SET_DEPOSIT_LIST';
    Const.GET_DEPOSIT_LIST = '/GET_DEPOSIT_LIST';
    Const.SET_DEPOSIT_LIMIT = '/SET_DEPOSIT_LIMIT';
    Const.GET_DEPOSIT_LIMIT = '/GET_DEPOSIT_LIMIT';
    Const.GET_PAYMENT_STATUS = '/GET_PAYMENT_STATUS';
    Const.GET_DEPOSIT_METHOD = '/GET_DEPOSIT_METHOD';
    Const.GET_DEPOSIT_BANK_LIST = '/GET_DEPOSIT_BANK_LIST';
    //withdrawal
    Const.RUN_GET_WITHDRAWAL_LIST = '/RUN_GET_WITHDRAWAL_LIST';
    Const.RUN_WITHDRAWAL_REQUEST_OTP = '/RUN_WITHDRAWAL_REQUEST_OTP';
    Const.RUN_WITHDRAWAL_CHECK_OTP = '/RUN_WITHDRAWAL_CHECK_OTP';
    Const.RUN_RESEND_EMAIL_LINK = '/RUN_RESEND_EMAIL_LINK';
    Const.RUN_GET_WITHDRAWAL_METHODS = '/RUN_GET_WITHDRAWAL_METHODS';
    Const.RUN_GET_WITHDRAWAL_DESC = '/RUN_GET_WITHDRAWAL_DESC';
    Const.SET_WITHDRAWAL_LIST = '/SET_WITHDRAWAL_LIST';
    Const.GET_WITHDRAWAL_LIST = '/GET_WITHDRAWAL_LIST';
    Const.SET_WITHDRAWAL_METHOD_RESPONSE = '/SET_WITHDRAWAL_METHOD_RESPONSE';
    Const.GET_WITHDRAWAL_METHOD_RESPONSE = '/GET_WITHDRAWAL_METHOD_RESPONSE';
    Const.GET_WITHDRAWAL_METHOD_RESPONSE_DEP = '/GET_WITHDRAWAL_METHOD_RESPONSE_DEP';
    Const.SET_WITHDRAWAL_METHOD_RESPONSE_DEP = '/SET_WITHDRAWAL_METHOD_RESPONSE_DEP';
    Const.GET_WITHDRAWAL_TYPE = '/GET_WITHDRAWAL_TYPE';
    Const.GET_WITHDRAWAL_METHOD = '/GET_WITHDRAWAL_METHOD';
    Const.GET_WITHDRAWAL_STATUS = '/GET_WITHDRAWAL_STATUS';
    //bonus
    Const.RUN_TRADING_BONUS = '/RUN_TRADING_BONUS';
    Const.RUN_BONUS_REQUEST_OTP = '/RUN_BONUS_REQUEST_OTP';
    Const.RUN_BONUS_CHECK_OTP = '/RUN_BONUS_CHECK_OTP';
    Const.RUN_GET_BONUS_LIST = '/RUN_GET_BONUS_LIST';
    Const.RUN_REMOVE_BONUS = '/RUN_REMOVE_BONUS';
    Const.RUN_RESEND_EMAIL_LINK_BONUS = '/RUN_RESEND_EMAIL_LINK_BONUS';
    Const.SET_BONUS_LIST = '/SET_BONUS_LIST';
    Const.GET_BONUS_LIST = '/GET_BONUS_LIST';
    Const.GET_BONUS_TYPE = '/GET_BONUS_TYPE';
    //support
    Const.RUN_GET_TICKET_LIST = '/RUN_GET_TICKET_LIST';
    Const.RUN_GET_TICKET_DETAIL = '/RUN_GET_TICKET_DETAIL';
    Const.RUN_TICKET_REQUEST_OTP = '/RUN_TICKET_REQUEST_OTP';
    Const.RUN_TICKET_CHECK_OTP = '/RUN_TICKET_CHECK_OTP';
    Const.RUN_TICKET_REPLY = '/RUN_TICKET_REPLY';
    Const.RUN_GET_TICKET_REASON_LIST = '/RUN_GET_TICKET_REASON_LIST';
    Const.RUN_TICKET_RESEND_OTP = '/RUN_TICKET_RESEND_OTP';
    Const.SET_TICKET_DATA = '/SET_TICKET_DATA';
    Const.GET_TICKET_DATA = '/GET_TICKET_DATA';
    Const.SET_TICKET_LIST = '/SET_TICKET_LIST';
    Const.GET_TICKET_LIST = '/GET_TICKET_LIST';
    Const.SET_TICKET_VIEW = '/SET_TICKET_VIEW';
    Const.GET_TICKET_VIEW = '/GET_TICKET_VIEW';
    Const.SET_TICKET_REASON_LIST = '/SET_TICKET_REASON_LIST';
    Const.GET_TICKET_REASON_LIST = '/GET_TICKET_REASON_LIST';
    Const.GET_REASON_LIST = '/GET_REASON_LIST';
    //dashboard charts
    Const.RUN_GET_PROFIT_CHART_DATA = '/RUN_GET_PROFIT_CHART_DATA';
    Const.RUN_GET_BALANCE_DATA = '/RUN_GET_BALANCE_DATA';
    Const.RUN_GET_EQUITY_DATA = '/RUN_GET_EQUITY_DATA';
    Const.RUN_GET_TRADING_DATA = '/RUN_GET_TRADING_DATA';
    Const.RUN_GET_IDENFY_TOKEN = '/RUN_GET_IDENFY_TOKEN';
    //bank-api
    Const.RUN_ADD_BANK = '/RUN_ADD_BANK';
    Const.RUN_GET_BANK_LIST = '/RUN_GET_BANK_LIST';
    Const.SET_BANK_LIST = '/SET_BANK_LIST';
    Const.GET_BANK_LIST = '/GET_BANK_LIST';
    Const.GET_DEPOSIT_LINK = '/GET_DEPOSIT_LINK';
    Const.GET_IMAGE_LINK_PORTFOLIO = '/GET_IMAGE_LINK_PORTFOLIO';
    //static
    Const.GET_LEGAL_DOC_LINK = '/GET_LEGAL_DOC_LINK';
    Const.GET_PRIVACY_POLICY_LINK = '/GET_PRIVACY_POLICY_LINK';
    Const.GET_CLIENT_AGREEMENT_LINK = '/GET_CLIENT_AGREEMENT_LINK';
    Const.GET_IDEN_PROCEDURE_LINK = '/GET_IDEN_PROCEDURE_LINK';
    Const.GET_ORDEREXE_POLICY_LINK = '/GET_ORDEREXE_POLICY_LINK';
    Const.GET_CONFLICT_INTEREST_LINK = '/GET_CONFLICT_INTEREST_LINK';
    Const.GET_CLIENT_CATEGORISATION_LINK = '/GET_CLIENT_CATEGORISATION_LINK';
    Const.GET_INVESTOR_COMPENSATION_LINK = '/GET_INVESTOR_COMPENSATION_LINK';
    Const.GET_LEVERAGE_JSON = '/GET_LEVERAGE_JSON';
    Const.GET_LEVERAGE_JSON_PL_COUNTRY = '/GET_LEVERAGE_JSON_PL_COUNTRY';
    Const.RUN_SUBMIT_CONSENT = '/RUN_SUBMIT_CONSENT';
    //Video Tutorials
    Const.RUN_GET_TUT_COURSE_CATEGORY = '/RUN_GET_TUT_COURSE_CATEGORY';
    Const.RUN_GET_VIDEO_TUTORIAL = '/RUN_GET_VIDEO_TUTORIAL';
    Const.SET_VIDEO_TUTORIAL = '/SET_VIDEO_TUTORIAL';
    Const.GET_VIDEO_TUTORIAL = '/GET_VIDEO_TUTORIAL';
    //Hoops data(market insights)
    Const.RUN_GET_HOOPS_DATA = '/RUN_GET_HOOPS_DATA';
    Const.GET_HOOPS_DATA = '/GET_HOOPS_DATA';
    Const.SET_HOOPS_DATA = '/SET_HOOPS_DATA';
    Const.RUN_UPDATE_FIRST_DEPOSIT = '/RUN_UPDATE_FIRST_DEPOSIT';
    //cancel withdrawal request
    Const.RUN_CANCEL_WITHDRAWAL_REQUEST = '/RUN_CANCEL_WITHDRAWAL_REQUEST';
    //Nuvei Resquest 
    Const.RUN_NUVEI_REQUEST = '/RUN_NUVEI_REQUEST';
    return Const;
}());
export { Const };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/fxView/provider/candle-history/lib/const.cls.ts
// module id = H1/N
// module chunks = 1